import payBalanceSagas from './payBalance'

// CODE_COMMENTS_11
export default [
  ...payBalanceSagas,
]
